import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { CONFIRMED_SHIFT_CHANGE_REASONS } from '../../constants'

const ShiftChangeReasonSelect = ({
    value,
    onChange,
    sx,
    fullWidth = true,
    size = 'medium',
    label = '変更理由',
    labelId = 'change-reason-label',
    testId = 'change-reason'
}) => (
    <FormControl
        fullWidth={fullWidth}
        size={size}
        sx={sx}
        onClick={event => event.stopPropagation()}
        onMouseDown={event => event.stopPropagation()}
    >
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
            labelId={labelId}
            label={label}
            value={value}
            onChange={event => onChange(event.target.value)}
            inputProps={{ 'data-testid': testId }}
        >
            {CONFIRMED_SHIFT_CHANGE_REASONS.map(reason => (
                <MenuItem key={reason.value} value={reason.value}>
                    {reason.label}
                </MenuItem>
            ))}
        </Select>
    </FormControl>
)

export default ShiftChangeReasonSelect
